/**
 * Web no-op. The native Payment Sheet is not available on web, so checkout is
 * gated to native and the web bundle never imports the native Stripe module.
 */
export default function StripeRootProvider({
  children,
}: {
  children: React.ReactElement;
}) {
  return <>{children}</>;
}
